import { NewNodeType } from 'enums/organisationMapEnums';
import { Organization } from 'models/CompanySetup/organization.model';
import { MetaData } from 'models/MetaData/metaData.model';

export const filterOrganisationList = (
  currentOrganisation: Organization,
  organisationListMeta: MetaData[],
  organisationList: Organization[],
  additionType?: NewNodeType
) => {
  const exclusionSet = new Set<string>();

  organisationList.forEach(organisation => {
    // Exclude main parent (no parentName)
    if (!organisation.organisationYearWise?.parentName) {
      exclusionSet.add(organisation.name ?? '');
    }

    // Exclude the currentOrganisation
    if (organisation.name === currentOrganisation.name) {
      exclusionSet.add(organisation.name ?? '');
    }

    // Exclude selectedOrganisation's immediate parent if adding a parent
    if (
      additionType === NewNodeType.PARENT &&
      organisation.name === currentOrganisation.organisationYearWise?.parentName
    ) {
      exclusionSet.add(organisation.name ?? '');
    }

    // Exclude selectedOrganisation's immediate child if adding a child
    if (
      additionType === NewNodeType.CHILD &&
      organisation.organisationYearWise?.parentName === currentOrganisation.name
    ) {
      exclusionSet.add(organisation.name ?? '');
    }
  });

  // Filter organisationListMeta based on the exclusion set
  return organisationListMeta
    .filter(metaItem => metaItem.name && !exclusionSet.has(metaItem.name))
    .map(organisation => {
      return { label: organisation.name, value: organisation.name };
    });
};
